import { Col, Row, Form, Input, Select, DatePicker, AutoComplete, InputNumber, Skeleton, Upload } from 'antd';
import _ from 'lodash';
import moment, { Moment } from 'moment';
import React, { ReactElement, useEffect, useState } from 'react';
import { DOCTORS_DEPARTMENTS, DOCTORS_QUALIFICATIONS } from '../../../../shared/constants/urlEndPoints';
import UploadImage from '../../../hospital/shared/UploadImage';
import SlotsCalendar from '../../shared/SlotsCalendar';
import Panel from './../../../../shared/components/card/Panel';
import {
  GUTTOR_SPACE, DEFAULT_GUID, CONSULTATION_TYPES, INVENTROY_CONSTANTS, INVENTORY_MESSAGE_CONSTANTS,
  VALIDATE_MESSAGES, COMMON_ERROR, APPLICATION_ID_2, HOSPITAL_MAX_FILE_SIZE, FILE_EXCEED_MESSAGE,
  HOSPITAL_SEAL_SUPPORTED_FORMATS,
  FETCH_FILE_BYTES,
} from './../../../../shared/constants/commonConstants';
import { DoctorDetails } from './../../../../shared/models/inventory.model';
import SendRequest from './../../../../shared/services/sendRequest.service';
import { FileDetail } from './../../../../shared/models/file.profile.model';
import {
  base64UrlEncode, capitalizeFirstLetter, centeredNotification, error, getAgeFromDob, getConsultationType, getDobFromAge, GetFirstElement,
  isDigitizationFeatureEnabled,
  removeCurrencySymbols, success,
} from './../../../../utils/utility';
import { doctorsImages, fetchDoctorsList } from '../../../../store/actions/inventoryAction';
import { useDispatch, useSelector } from 'react-redux';
import { SaveDoctorDetails } from '../../shared/SaveDoctors';
import { useHistory } from 'react-router-dom';
import ApplicationDetail from '../../../../shared/services/applicationDetail.service';
import NumberFormat from 'react-number-format';
import { FormTextInput } from '../../../../shared/components/crmFormElement/FormInput';
import { doctorNameValidation } from '../../../crm/inPatient/service/crmUtils';
import { UploadProps } from 'antd/lib/upload';
import { UploadChangeParam, UploadFile } from 'antd/lib/upload/interface';
import './DoctorProfile.less';
import { ReactComponent as File_Icon } from '../../../../assets/images/svg/File_Upload.svg';
import { ReactComponent as Uploaded_File_Icon } from '../../../../assets/images/svg/Hosp_Seal.svg';
import { ReactComponent as DeleteIcon } from '../../../../assets/images/svg/Doctor_Sign_Cross_Icon.svg';
import { ReactComponent as Cross_Icon } from '../../../../assets/images/svg/Cross_Red_Filled_Icon.svg';
import loader from '../../../../assets/images/lottie-json/lottie_loading.json';
import Lottie from 'react-lottie';

const DoctorProfileForm = ({ data, isSubmit, submitAgain }: any): ReactElement => {
  const { Option } = Select;
  const [personalForm] = Form.useForm();
  const [professionalForm] = Form.useForm();
  const [consultationForm] = Form.useForm();
  const [signatureForm] = Form.useForm();
  const [departments, setDepartments] = useState(null as any);
  const [qualifications, setQualifications] = useState(null as any);
  const [depSelected, setDepSelected] = useState(null as any);
  const [docImage, setDocImage] = useState(null as any);
  const [userId, setUserId] = useState(0);
  const [isDataLoaded, setIsDataLoaded] = useState(false);
  const dispatch = useDispatch();
  const history = useHistory();
  const [qualSelected, setQualSelected] = useState(null as any);
  const [imageUrl, setImageUrl] = useState('');
  const [fileList, setFileList] = useState<UploadFile<any>[]>([]);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const appdetail = ApplicationDetail.instance;
  const selectedDoctor = useSelector(({ inventory: { selectedDoctor: doctorData } }: any): DoctorDetails[] => doctorData);
  const doctorsList = useSelector(({ inventory: { doctorsList: doctorList } }: any): DoctorDetails[] => doctorList);

  const layout = {
    labelCol: { span: 24 },
    wrapperCol: { span: 24 },
  };

  useEffect((): void => {
    if (isSubmit || submitAgain) {
      onSaveProfile();
    }
  }, [isSubmit, submitAgain]);

  useEffect((): void => {
    if (data) {
      setInitialFields();
    }
  }, [data]);

  useEffect((): any => {
    // After file is uploaded, set the loader to show and then delay showing the image
    if (isLoading) {
      const timer = setTimeout((): any => {
        setIsLoading(false);
      }, 900);
      return (): any => clearTimeout(timer);
    }
  }, [isLoading]);

  useEffect((): any => {
    if (selectedDoctor) {
      getFileBytes(selectedDoctor?.['professionalDetail']?.['doctorSignature']);
    }
  }, [selectedDoctor]);

  useEffect((): void => {
    fetchDepartments();
    if (!data) {
      setIsDataLoaded(true);
    } else {
      setTimeout((): void => {
        setIsDataLoaded(true);
      }, 600);
    }
  }, []);

  const fetchDepartments = async (): Promise<void> => {
    const departmentResponse = await SendRequest.instance.get(process.env.REACT_APP_INVENTORY_API_BASE_URL + DOCTORS_DEPARTMENTS);
    if (departmentResponse && departmentResponse.isSuccess && departmentResponse.packageDetails) {
      const dptmnt = [] as any;
      departmentResponse.packageDetails.map((i: any): any => {
        dptmnt.push({
          id: i.id,
          name: i.name,
          description: i.description,
          groupId: i.groupId,
          groupName: i.groupName,
          isActive: i.isActive,
          value: i.name,
          key: i.id,
        });
      });
      setDepartments(_.uniqBy(dptmnt, 'name'));
    } else if (departmentResponse && departmentResponse.errorMessage) {
      error(departmentResponse.errorMessage);
    } else {
      error(INVENTROY_CONSTANTS.noDataFound);
    }
  };

  const fetchQualifications = async (dpId: number): Promise<void> => {
    setQualifications(null);
    if (dpId) {
      const qualificationsResponse = await SendRequest.instance.get(process.env.REACT_APP_INVENTORY_API_BASE_URL +
        DOCTORS_QUALIFICATIONS + dpId);
      if (qualificationsResponse && qualificationsResponse.isSuccess && qualificationsResponse.qualifications) {
        const qual = [] as any;
        qualificationsResponse.qualifications?.map((i: any): any => {
          qual.push({
            name: i,
            value: i,
            key: i,
          });
        });
        setQualifications(qual);
      } else if (qualificationsResponse && qualificationsResponse.errorMessage) {
        error(qualificationsResponse.errorMessage);
      } else {
        error(INVENTROY_CONSTANTS.noDataFound);
      }
    }
  };

  const getGender = (gender: any): string => {
    return (gender?.toLowerCase() === 'male' || gender?.toLowerCase() === 'm') ? INVENTROY_CONSTANTS.male :
      (gender?.toLowerCase() === 'female' || gender?.toLowerCase() === 'f') ? INVENTROY_CONSTANTS.female : INVENTROY_CONSTANTS.both;
  };

  const setInitialFields = (): void => {
    if (data.personalDetail && !_.isEmpty(data.personalDetail)) {
      const { personalDetail } = data;
      personalForm.setFieldsValue({
        doctorName: capitalizeFirstLetter(personalDetail?.name),
        gender: getGender(personalDetail?.gender),
        age: getAgeFromDob(personalDetail?.dateOfBirth),
      });
    }
    if (data.professionalDetail && !_.isEmpty(data.professionalDetail)) {
      const { professionalDetail } = data;
      professionalForm.setFieldsValue({
        registrationNo: professionalDetail?.registrationNumber,
        practiceStarted: (professionalDetail?.practiceStartedOn &&
          new Date(professionalDetail?.practiceStartedOn).getFullYear() >= 1900) ?
          moment(professionalDetail?.practiceStartedOn) : moment(new Date()),
        department: professionalDetail?.departmentName,
        collegename: professionalDetail?.collegeName,
      });
      if (professionalDetail.qualifications && professionalDetail.qualifications.length > 0) {
        fetchQualifications(professionalDetail?.departmentId);
        setDepSelected(professionalDetail?.departmentId);
        setQualSelected(professionalDetail.qualifications[0].qualificationName);
        professionalForm.setFieldsValue({
          qualification: professionalDetail?.qualifications[0].qualificationName,
          additionalqualification: professionalDetail?.qualifications[0].additionalQualification,
        });
      }
    }
    if (data.consultationDetail && !_.isEmpty(data.consultationDetail)) {
      const { consultationDetail } = data;
      consultationForm.setFieldsValue({
        consultationType: getConsultationType(data?.consultationDetail?.consultationType),
        followupConsultation: consultationDetail?.followUpCount || null,
        consultationFee: consultationDetail?.consultationFee || null,
        discountedFee: consultationDetail?.discountedFee || null,
      });
    }
  };

  const onSaveProfile = async (type?: string): Promise<void> => {
    let validationErrors = null as any;
    await Promise.all([personalForm.validateFields(), professionalForm.validateFields(), consultationForm.validateFields()])
      .catch((er: any): void => {
        validationErrors = er;
      }).finally();
    if (validationErrors && validationErrors.errorFields && validationErrors.errorFields.length > 0) {
      return;
    }

    if (!depSelected) {
      error(INVENTORY_MESSAGE_CONSTANTS.departmentNotFound);
      return;
    }

    if (!qualSelected) {
      error(INVENTORY_MESSAGE_CONSTANTS.qualificationName);
      return;
    }

    const personalDetail = personalForm.getFieldsValue();
    const professionalDetail = professionalForm.getFieldsValue();
    const consultationDetail = consultationForm.getFieldsValue();
    const updatedDoctorsList = Array?.isArray(doctorsList)
    ? doctorsList?.find((v: any): boolean => v?.id === data?.id)
    : null;
    const doctorDetails: DoctorDetails = {
      id: data?.id || userId || 0,
      isActive: true,
      profileId: ApplicationDetail.instance.getProfileId(),
      statusName: INVENTROY_CONSTANTS.submit,
      personalDetail: {
        name: personalDetail.doctorName,
        dateOfBirth: personalDetail.age ? getDobFromAge(personalDetail.age) : null as any,
        gender: getGender(personalDetail?.gender),
        imageId: docImage ? docImage[0].fileGuid : (data && data.personalDetail.imageId &&
          data.personalDetail.imageId !== DEFAULT_GUID) ? data.personalDetail.imageId : null,
      },
      professionalDetail: professionalDetail?.registrationNo ||
        (type === INVENTROY_CONSTANTS.consultation) ? {
        registrationNumber: professionalDetail?.registrationNo,
        doctorSignature: imageUrl ? (fileList?.[0]?.response['fileUploadDetails']?.[0]?.fileGuid ||
          updatedDoctorsList?.['professionalDetail']?.['doctorSignature']) : null,
        practiceStartedOn: professionalDetail?.practiceStarted,
        qualifications: [{
          qualificationName: qualSelected,
          additionalQualification: professionalDetail.additionalqualification,
        }],
        departmentId: depSelected,
        collegeName: professionalDetail?.collegeName,
      } : null as any,
      consultationDetail: consultationDetail?.consultationType ? {
        consultationType: consultationDetail?.consultationType === CONSULTATION_TYPES[0].value ? 1 : 2,
        consultationFee: removeCurrencySymbols(consultationDetail?.consultationFee),
        followUpCount: consultationDetail?.followupConsultation,
        discountedFee: removeCurrencySymbols(consultationDetail?.discountedFee),
      } : null as any,
    };
    const response: any = await SaveDoctorDetails(doctorDetails);
    if (response && response.isSuccess) {
      updateStore();
      setUserId(response.doctorIds[0]);
      success(`Profile ${data && data.id ? 'updated ' : 'created '} successfully`);
      history.push(`${INVENTROY_CONSTANTS.viewDoctorProfile}/${base64UrlEncode(GetFirstElement(response?.doctorIds))}`);
      dispatch(doctorsImages(null));
    } else if (response && response.errorMessage) {
      error(response.errorMessage);
    } else {
      error(INVENTROY_CONSTANTS.profileSaveFail);
    }
    return;
  };

  const onFilter = (inputValue: string, option: any): boolean => {
    return option.value.toUpperCase().includes(inputValue.toUpperCase());
  };

  const updateStore = (): void => {
    dispatch(fetchDoctorsList({}));
  };

  const getFiles = (files: FileDetail): void => {
    setDocImage(files);
  };

  const handleChange = (value: any, type: string): void => {
    if (type === INVENTROY_CONSTANTS.dep) {
      const selectedDepartment = departments.filter((v: any): any => value === v.value);
      if (selectedDepartment && selectedDepartment.length > 0) {
        fetchQualifications(selectedDepartment[0].id);
        setDepSelected(selectedDepartment[0].id);
      }
    }
    if (type === INVENTROY_CONSTANTS.qual) {
      setQualSelected(value);
    }
  };

  const onQualChange = (e?: any): any => {
    if (!e) {
      professionalForm.setFieldsValue({ qualification: '', category: '' });
    }
  };

  const onDepartmentClear = (e?: any): any => {
    setQualifications(null);
  };

  // File validations
  const fileBeforeUpload = (file: File): boolean => {
    if (file?.size > HOSPITAL_MAX_FILE_SIZE) {
      centeredNotification(FILE_EXCEED_MESSAGE);
      return false;
    }

    if (!HOSPITAL_SEAL_SUPPORTED_FORMATS?.['fileFormats']?.includes(file?.type)) {
      centeredNotification(HOSPITAL_SEAL_SUPPORTED_FORMATS?.['fileErrorMessage']);
      return false;
    }
    return true;
  };

  const getFileBytes = async (guid: any): Promise<any> => {
    const request = {
      applicationId: APPLICATION_ID_2,
      fileIdentifiers: [guid],
    };
    if (guid) {
      const result = await SendRequest.instance.post(process.env.REACT_APP_BASE_URL + FETCH_FILE_BYTES, request);
      setImageUrl(result?.fileDetails?.[0]?.fileBytes);
      return result;
    } else {
      setImageUrl('');
    }
  };

  const draggerActions: UploadProps = {
    showUploadList: true,
    beforeUpload: fileBeforeUpload,
    multiple: true,
    action: process.env.REACT_APP_BASE_URL + 'File/Upload',
    // to be commented when moving to production
    // headers: { accessToken: appdetail.getAccessToken() },
    withCredentials: true,
    onChange: async (info: UploadChangeParam<UploadFile<any>>): Promise<any> => {

      if (info?.file?.status === 'done') {
        const { isSuccess, errorMessage, fileUploadDetails } = info?.file?.response || {};
        const formData = new FormData() as any;
        formData.append('FileUploadType', INVENTROY_CONSTANTS.doctor_signature);

        if (isSuccess) {
          setFileList((prevList: any): any => [...prevList, info.file]);
          localStorage?.setItem(INVENTROY_CONSTANTS.doctor_signature, fileUploadDetails?.[0]?.fileGuid);
          getFileBytes(fileUploadDetails?.[0]?.fileGuid);
          setIsLoading(true);
        } else {
          centeredNotification(errorMessage || COMMON_ERROR);
        }
      } else if (info?.file?.status === 'removed') {
        setFileList((prevList: any): any => prevList.filter((f: any): any => f.uid !== info.file.uid));
      }
    },
    fileList,
    data: (file: any): any => {
      return {
        FileUploadType: INVENTROY_CONSTANTS.doctor_signature, // FileUploadType to be sent with the upload
        ApplicationId: APPLICATION_ID_2,
      };
    },
  };

  const CenteredContainer = ({ children }: any): any => {
    return <div className="sign-centered-container">{children}</div>;
  };

  const deleteFile = (): any => {
    setFileList([]);
    setImageUrl('');
  };

  const defaultLottieOptions = {
    loop: true,
    autoplay: true,
    animationData: loader,
    rendererSettings: {
      preserveAspectRatio: 'xMidYMid slice',
    },
  };

  return (
    <Row gutter={GUTTOR_SPACE}>
      <Col md={16}>
        <Form form={personalForm} {...layout} validateMessages={VALIDATE_MESSAGES}>
          <Row>
            <Col md={24}>
              <Panel title={INVENTROY_CONSTANTS.personalDetails}>
                <Row gutter={GUTTOR_SPACE}>
                  <Col md={14}>
                    <Row>
                      <Col md={24}>
                        <FormTextInput detail={{
                          key: 'doctorName',
                          label: 'Doctor Name',
                          size: 24,
                          required: true,
                          rules: [doctorNameValidation],
                          addonBefore: 'Dr.',
                          className: 'inventory-doctor',
                        }}
                        />
                      </Col>
                    </Row>
                    <Row gutter={GUTTOR_SPACE}>
                      <Col md={16}>
                        <Form.Item name="gender" label="Gender" rules={[{ required: true }]}>
                          <Select
                            placeholder="Select gender"
                          >
                            <Option value="M">Male</Option>
                            <Option value="F">Female</Option>
                            <Option value="ThirdGender">Third gender</Option>
                          </Select>
                        </Form.Item>
                      </Col>
                      <Col md={8}>
                        <Form.Item
                          label="Age (25 - 80) years"
                          name="age"
                          rules={[{ required: true }]}
                        >
                          <InputNumber style={{ width: '100%' }} min={25} max={80} />
                        </Form.Item>
                      </Col>
                    </Row>
                  </Col>
                  <Col md={10} style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', textAlign: 'center' }}>
                    {isDataLoaded ? (
                      <UploadImage getFiles={getFiles} imageUrl={data?.imageUrl} imageTitle={'Upload Doctor Image'} />
                    ) : (
                      <Skeleton.Avatar active={true} style={{ height: '80px', width: '80px' }} />
                    )
                    }
                  </Col>
                </Row>
              </Panel>
            </Col>
          </Row>
        </Form>

        {(isDigitizationFeatureEnabled(appdetail?.getIsDoctorSignatureFeatureEnabled())) && <Form form={signatureForm} {...layout}>
          <Row>
            <Col md={24}>
              <Panel title={INVENTROY_CONSTANTS.signature} className={imageUrl ? '' : 'upload-doc-sign-panel'}>

                {imageUrl ?
                  <div className="signature-container">
                    <Row className="updated-signature-container">
                      <Col md={4} className="display-flex col-centered">
                        <Uploaded_File_Icon />
                        <p className="uploaded-hosp-name">{INVENTROY_CONSTANTS.FILE_NAME}</p>
                      </Col>
                      {!isLoading && <Col md={10} className="sign-uploaded-text col-centered">
                        <span className="delete-icon-signature" onClick={deleteFile}><DeleteIcon /></span>
                      </Col>}
                      {isLoading ?
                        <><Col md={10} className="lottie-icon-loader">
                          <Lottie options={defaultLottieOptions} />
                        </Col><Col md={4} className="cross-icon-filled"><Cross_Icon /></Col></>
                        :
                        <Col md={10} className="image-cls">
                          <img className="doctor-sign-image hospital-seal" src={`data:image/jpeg;base64,${imageUrl}`} alt="Hospital Logo" />
                        </Col>
                      }
                    </Row>
                  </div> :
                  <><span className="doctor-sign-file-icon"><File_Icon /></span><Upload
                    {...draggerActions}
                    itemRender={(): any => null}
                  >
                    <CenteredContainer>
                      <p className="upload-doc-sign">Upload Doctor Signature</p>
                    </CenteredContainer>

                    <CenteredContainer>
                      <p className="drag-drop-text">Drag & Drop your file(s) here.</p>
                    </CenteredContainer>

                    <CenteredContainer>
                      <span className="fileType">
                        {INVENTORY_MESSAGE_CONSTANTS.file_message}
                        <br />
                        <span className="exntension-text">{INVENTORY_MESSAGE_CONSTANTS.file_format?.join(', ')}</span>
                        <br />
                        <span className="fileSize">{FILE_EXCEED_MESSAGE}</span>
                      </span>
                    </CenteredContainer>
                  </Upload></>}

              </Panel>
            </Col>
          </Row>

        </Form>}

        <Form form={professionalForm} {...layout}>
          <Row>
            <Col md={24}>
              <Panel title={INVENTROY_CONSTANTS.professionalDetails}>
                <Row gutter={GUTTOR_SPACE}>
                  <Col sm={8}>
                    <Form.Item
                      label="Registration No."
                      name="registrationNo"
                      rules={[{ required: true, max: 20, message: 'Please enter valid registration No.' }]}
                    >
                      <Input />
                    </Form.Item>
                  </Col>
                  <Col sm={8}>
                    <Form.Item
                      label="Practice started"
                      name="practiceStarted"
                      initialValue={moment(new Date())}
                      rules={[{ required: true }]}
                    >
                      <DatePicker allowClear={false}
                        disabledDate={(d: Moment): any => !d || (d.isBetween(new Date('1960-01-01'), new Date())) ? false : true}
                        style={{ width: '100%' }} />
                    </Form.Item>
                  </Col>
                  <Col sm={8} style={{ display: 'none' }}>
                    <Form.Item name="collegeName" label="College name" rules={[{ required: false }]}>
                      <Input
                        className="w-100"
                        allowClear={true}
                        placeholder="College name"
                      />
                    </Form.Item>
                  </Col>
                </Row>
                <Row gutter={GUTTOR_SPACE}>
                  <Col sm={8}>
                    <Form.Item name="department" label="Department" rules={[{ required: true }]}>
                      <AutoComplete
                        allowClear={true}
                        className="w-100"
                        placeholder="Search department"
                        onClear={onDepartmentClear}
                        onSelect={(e: any): void => handleChange(e, 'dep')}
                        filterOption={onFilter}
                        options={departments}
                      >
                        <Input />
                      </AutoComplete>
                    </Form.Item>
                  </Col>
                  <Col sm={8}>
                    <Form.Item name="qualification" label="Qualification" rules={[{ required: true }]}>
                      <AutoComplete
                        className="w-100"
                        allowClear={true}
                        placeholder="Select qualification"
                        onChange={onQualChange}
                        onClear={onQualChange}
                        onSelect={(e: any): void => handleChange(e, 'qual')}
                        filterOption={onFilter}
                        options={qualifications}
                      >
                        <Input />
                      </AutoComplete>
                    </Form.Item>
                  </Col>
                  <Col sm={8}>
                    <Form.Item name="additionalqualification" label="Additional qualification" rules={[{ required: false }]}>
                      <Input
                        className="w-100"
                        allowClear={true}
                        placeholder="Additional qualification"
                      />
                    </Form.Item>
                  </Col>
                </Row>
              </Panel>
            </Col>
          </Row>
        </Form>
        <Form form={consultationForm} {...layout}>
          <Row>
            <Col md={24}>
              <Panel title={INVENTROY_CONSTANTS.consultationDetails}>
                <Row gutter={GUTTOR_SPACE}>
                  <Col sm={12}>
                    <Form.Item name="consultationType" label="Consultation type" rules={[{ required: true }]}>
                      <AutoComplete
                        placeholder="Select consultation type"
                        options={CONSULTATION_TYPES}
                      >
                        <Input />
                      </AutoComplete>
                    </Form.Item>
                  </Col>
                  <Col sm={12}>
                    <Form.Item name="followupConsultation" label="Follow up fee waiver (In days- 0-10)"
                      rules={[{ required: false }]}>
                      <InputNumber max={10} min={0} style={{ width: '100%' }} />
                    </Form.Item>
                  </Col>
                </Row>
                <Row gutter={GUTTOR_SPACE}>
                  <Col sm={12}>
                    <Form.Item name="consultationFee" label="Consultation fee" rules={[{ required: true }]}>
                      <NumberFormat
                        decimalScale={2}
                        customInput={Input}
                        thousandSeparator={true}
                        thousandsGroupStyle="lakh"
                        prefix="₹ "
                        autoComplete="off"
                        placeholder="Enter consultation fee"
                        minLength={1}
                        maxLength={9}
                      />
                    </Form.Item>
                  </Col>
                  <Col sm={12}>
                    <Form.Item name="discountedFee" label="Discounted fee" rules={[{ required: false }]}>
                      <NumberFormat
                        decimalScale={2}
                        customInput={Input}
                        thousandSeparator={true}
                        thousandsGroupStyle="lakh"
                        prefix="₹ "
                        autoComplete="off"
                        placeholder="Enter discounted fee"
                        maxLength={9}
                      />
                    </Form.Item>
                  </Col>
                </Row>
              </Panel>
            </Col>
          </Row>
        </Form>
      </Col>
      <Col md={8}>
        <SlotsCalendar title={INVENTROY_CONSTANTS.weeklySchedule} action={data ? 'Update' : 'Save'} data={data} userId={userId}
          isReadOnly={!data && !userId} />
      </Col>
    </Row>
  );
};

export default DoctorProfileForm;
